import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

// QR sebagai <img> (data URL). size = lebar tampilan px.
export default function QrImg({ text, size = 260, style, testid }) {
  const [src, setSrc] = useState('');
  useEffect(() => {
    let alive = true;
    if (!text) { setSrc(''); return undefined; }
    QRCode.toDataURL(text, { errorCorrectionLevel: 'M', margin: 2, width: Math.max(256, size * 2), color: { dark: '#111111', light: '#FFFFFF' } })
      .then((u) => { if (alive) setSrc(u); })
      .catch(() => { if (alive) setSrc(''); });
    return () => { alive = false; };
  }, [text, size]);
  if (!src) return <div style={{ width: size, height: size, background: '#f3f3f3', ...style }} />;
  return <img src={src} alt="QR" width={size} height={size} style={{ display: 'block', imageRendering: 'pixelated', ...style }} data-testid={testid} />;
}
